import React from "react";

const IconQuestion = () => (
  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.5 8H5.5V7H4.5V8ZM5 0C2.24 0 0 2.24 0 5C0 7.76 2.24 10 5 10C7.76 10 10 7.76 10 5C10 2.24 7.76 0 5 0ZM5 9C2.795 9 1 7.205 1 5C1 2.795 2.795 1 5 1C7.205 1 9 2.795 9 5C9 7.205 7.205 9 5 9ZM5 2C3.895 2 3 2.895 3 4H4C4 3.45 4.45 3 5 3C5.55 3 6 3.45 6 4C6 5 4.5 4.875 4.5 6.5H5.5C5.5 5.375 7 5.25 7 4C7 2.895 6.105 2 5 2Z" fill="#A9A9C4"/>
  </svg>
);

export default IconQuestion;
